import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#arrowLeft'
const _hoisted_2 = {
  key: 0,
  class: "more"
}
const _hoisted_3 = {
  key: 1,
  class: "btn btn--white"
}
const _hoisted_4 = {
  class: "pagination",
  ref: "pagination"
}
const _hoisted_5 = { class: "pagination__container" }
const _hoisted_6 = { class: "pagination__info" }
const _hoisted_7 = { class: "pagination__text" }

import type { IPagination } from "@/models/models";
  import { computed, onMounted, PropType, ref, watch } from "vue";
  import { useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    source: {
      type: Object as PropType<IPagination> | null,
      required: true,
    },
    moreCallback: {
      type: Promise,
    },
  },
  emits: ["showMore"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  let isLoadingShowMore = ref<boolean>(false as boolean);

  const items = computed(() => {
    let result = [];

    if (props.source.pageCount < 2) return [];

    let caseIt = false,
      changes = false;

    let pageCount = props.source.pageCount;
    let currentPage = props.source.page;
    let pageStart = currentPage - 2;
    let pageEnd = currentPage + 2;

    if (pageStart + 3 > pageCount) pageStart = pageCount - 3;

    if (pageStart < 1) pageStart = 1;

    // if (pageEnd <= 5) {
    //   pageEnd = 5;
    //   caseIt = true;
    // }
    if (pageCount == 6 || pageCount == 7) {
      changes = true;
      switch (currentPage) {
        case 1:
          pageStart = 1;
          pageEnd = 3;
          break;
        case 2:
          pageStart = 2;
          pageEnd = 4;
          break;
        case 3:
          pageStart = 2;
          pageEnd = 4;
          break;
        case 4:
          pageStart = 4;
          pageEnd = 4;
          break;
      }
    }
    // if (pageEnd >= pageCount) pageEnd = pageCount - 1;

    // if (pageStart > 1) {
    //   result.push({
    //     label: 1,
    //     route: getRoute(1),
    //   });
    // }

    // if (pageStart > 2) {
    //   result.push({
    //     label: "...",
    //     selected: false,
    //     route: getRoute(Math.round(pageStart / 2)),
    //   });
    // }

    do {
      if (currentPage == pageStart) {
        result.push({
          label: pageStart,
          selected: currentPage == pageStart,
          route: getRoute(pageStart),
        });
      }
      pageStart++;
    } while (pageStart <= pageEnd);

    let dot = Math.round(pageEnd + (pageCount - pageEnd) / 2);

    if (pageEnd < dot - 1) {
      // result.push({
      //   label: "...",
      //   selected: false,
      //   route: getRoute(dot),
      // });
    } else {
      if (caseIt == true) {
        result.push({
          label: pageStart,
          selected: currentPage == pageStart,
          route: getRoute(pageStart),
        });
      }
    }

    // result.push({
    //   label: pageCount,
    //   selected: currentPage == pageStart,
    //   route: getRoute(pageCount)
    // });

    return result;
  });

  const back = computed(() => {
    if (props.source.page > 1) {
      return getRoute(props.source.page - 1);
    }
    return null;
  });

  const next = computed(() => {
    if (props.source.page != props.source.pageCount) {
      return getRoute(props.source.page + 1);
    }
    return null;
  });

  function getRoute(page: number) {
    const router = useRouter();
    if(router) {
      return {
        path: router.currentRoute.value?.path,
        params: router.currentRoute.value.params,
        query: { ...router.currentRoute.value.query, ...{ page: page } },
      };
    }
  }

  function showMore() {
    isLoadingShowMore.value = true
    emit("showMore", props.source.page + 1);
  }

  watch(
    () => props.source,
    async (newVal, oldVal) => {
      isLoadingShowMore.value = false
    },
    {
      deep: true,
      immediate: false,
    }
  );


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.source.page != props.source.pageCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(isLoadingShowMore))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore())),
                class: "btn btn--white"
              }, " Показать еще "))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(!_unref(isLoadingShowMore) ? "" : "...."), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            class: _normalizeClass(["pagination__direction", { 'pagination__direction--disabled': !back.value || _unref(isLoadingShowMore)}]),
            to: back.value || ''
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                width: "8",
                height: "12"
              }, [
                _createElementVNode("use", { "xlink:href": _hoisted_1 })
              ], -1)
            ])),
            _: 1
          }, 8, ["class", "to"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "pagination__page"
            }, _toDisplayString(item.label), 1))
          }), 128)),
          _createVNode(_component_RouterLink, {
            class: _normalizeClass(["pagination__direction pagination__direction--next", { 'pagination__direction--disabled': !next.value || _unref(isLoadingShowMore) }]),
            to: next.value || ''
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                width: "8",
                height: "12"
              }, [
                _createElementVNode("use", { "xlink:href": _hoisted_1 })
              ], -1)
            ])),
            _: 1
          }, 8, ["class", "to"])
        ]),
        _createElementVNode("div", _hoisted_7, "из " + _toDisplayString(__props.source.pageCount), 1)
      ])
    ], 512)
  ], 64))
}
}

})